export const API_KEY = {
    KAKAO: '9cd069a3e24da928e2e6c5796067b204'
};

export const HOST = {
    APP_CONTEXT_PATH: ''
}
